/**
 * Removes undefined and null values from an array
 */
export function compact<T>(array: readonly (T | undefined | null)[]): T[] {
  return array.filter((item): item is T => item != null);
}
